<template>
    <div>
        <v-form ref="reference" v-model="valid">
            <v-row justify="center">
                <v-col cols="6">
                    <v-row justify="center">
                        <v-col class="col-6">
                            <v-text-field class="text-field" label="First Name *" v-model="reference.FirstName" :rules="this.$parent.notEmpty" outlined></v-text-field>
                        </v-col>
                        <v-col class="col-6">
                            <v-text-field class="text-field" label="Last Name *" v-model="reference.LastName" :rules="this.$parent.notEmpty" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col class="col-6">
                            <v-text-field class="text-field" label="Email *" v-model="reference.Email" :rules="this.$parent.isEmail" outlined></v-text-field>
                        </v-col>
                         <v-col class="col-6">
                            <v-text-field class="text-field" label="Phone *" v-model="reference.Phone" :rules="this.$parent.notEmpty" outlined></v-text-field>
                        </v-col>                       
                    </v-row>
                    <v-row justify="center" style="margin-top: 20px">
                        <v-col class="col-12">
                            <v-text-field class="text-field" v-model="reference.How_Do_You_Know_the_Applicant__c" :rules="this.$parent.isRequired&&lengthCheckMinMax" label="How do you know the applicant? *" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col class="col-12">
                            <v-select class="text-field" :items="[1,2,3,4,5,6,7,8,9,10,11,12]" v-model="reference.How_Many_Years_know_the_applicant__c" :rules="this.$parent.isRequired" label="Years you have known the applicant *" outlined></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12" style="margin-top: 30px">
                            <div class="question-field">Do you endorse this student for a GO-PEF Scholarship? *</div>
                            <v-radio-group v-model="reference.Endorsement__c" :value="reference.Endorsement__c" :rules="this.$parent.isRequired" row>
                            <v-radio class="radio-button-field" color="#ea7f1d" label="Yes" value="Yes" :style="reference.Endorsement__c == 'Yes' ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            <v-radio class="radio-button-field" color="#ea7f1d" label="No" value="No" :style="reference.Endorsement__c == 'No' ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row v-if="reference.Endorsement__c == 'Yes' || reference.Endorsement__c == 'No'">
                        <v-col class="col-12">
                            <div class="question-field" v-if="reference.Endorsement__c == 'No'">Could you please share with us details as to why you wouldn't endorse this student for a Scholarship? *</div>
                            <div class="question-field" v-if="reference.Endorsement__c == 'Yes'">Please provide a supporting statement for this student *</div>
                            <v-textarea class="text-area" outlined counter v-model="reference.Endorsement_Reason__c" ref="endoseReason" :rules="lengthCheck"></v-textarea>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
        <v-row class="row-height-80" justify="center">
            <v-col class="row-height-80" cols="6">
                <button v-if="!submitting" :disabled="!valid || submitting" class="submit-button submit-button-text" :style="cssVars" @click="submitReference">SUBMIT REFERENCE</button>
                <button v-else class="submit-button submit-button-text"><span class="spin">&bull;</span></button>
            </v-col>
        </v-row>
    </div>
</template>

<script>

export default {
    data: function() {
        return {
            valid: false,
            submitting: false,
            endorse_reason_min: 600,
            endorse_reason_max: 1000,
            community_min: 1,
            community_max: 100,
        }
    },
    watch: {
        'reference.Endorsement__c': function(val) {

            this.endorse_reason_min = val == 'No' ? 400 : 600;
            this.endorse_reason_max = val == 'No' ? 700 : 1000;
            this.$refs['endoseReason'].validate();
            
        }
    },
    computed: {
        reference() {
            return this.$parent.reference
        },
        lengthCheck() {
            return  [v => !v ? !!v || 'The field cannot be empty': v.length >= this.endorse_reason_min && v.length <= this.endorse_reason_max || `Answer length: ${this.endorse_reason_min} min - ${this.endorse_reason_max} max (characters)`] 
        },
        cssVars() {
            return {
                '--submit-button-color': this.valid ? '#ea7f1d' : '#d5d5d5',
                '--submit-button-text-color': this.valid ? '#ffffff' : '#8e8e8c'
            }
        },
        lengthCheckMinMax() {
            return [v => !v ? !!v || 'The field cannot be empty': v.length >= this.community_min && v.length <= this.community_max || 'Please Shorten your answer into 100 characters']
        },
    },
    methods:{
        async submitReference(){

            this.submitting = true;
            if(!this.$refs['reference'].validate()){
                this.submitting = false;
                setTimeout(() => {
                    const el = document.getElementsByClassName('error-text')[0];
                    el && el.scrollIntoView({behavior: 'smooth'});
                }, 500)
                return
            }

            this.reference['Feedback_Submitted__c'] = true;
            await this.$parent.saveReference()
            this.$parent.submitted = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.primary-font{
    font-family: Hind;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
}

.text-field {
    @extend .primary-font;
    height: 65px;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: -0.15px;
    color: #6a6a66;
}

.radio-button-field
{
    @extend .text-field;
    height: 24px;
    line-height: 1.5;
    letter-spacing: normal;
    color: '#3a3a3a';
}

.text-area
{
    @extend .primary-font;
}

.question-field{
    @extend .primary-font;
    font-size: 16px;
    line-height: 1.44;
    letter-spacing: normal;
    color: black;
    margin-bottom: 10px;
}

.submit-button
{
    width: 100%;
    height: 53px;
    border-radius: 3px;
    background-color: var(--submit-button-color);
    margin-top: 30px;
} 

.submit-button-text
{
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1px;
    text-align: center;
    color: var(--submit-button-text-color);
}

.spin {
    color: white;
    display: flex;
    justify-content: center;
    -webkit-animation: dotting 2s infinite;
    -o-animation: dotting 2s infinite;
    animation: dotting 2s infinite;
}


@keyframes dotting {
    0% {
        text-shadow: 0 0 0 currentColor;
    }
    33% {
        text-shadow: -20px 0 0 currentColor;
    }
    66% {
        text-shadow: -20px 0 0 black, 20px 0 0 currentColor;
    }
    100% {
        text-shadow: 0px 0 0 currentColor;
    }
}

</style>
